import { TestType } from "../../constants/enum";
import { IGetAllQuestions } from "../../models/response/ITestQuestion";

export const initialState: IGetAllQuestions = {
    TestType: "",
    Questions: [],
    Questions_2: [],
};